export const checkIsLastSelectedCargoItem = (
  cargoItems: number[],
  selectedCargoItems: Set<number>,
  currentCargoItemId: number,
) => {
  let result = true;

  if (cargoItems.length <= 1) return result;

  for (const cargoItemId of cargoItems) {
    if (!selectedCargoItems.has(cargoItemId) && cargoItemId !== currentCargoItemId) {
      result = false;
      break;
    }
  }

  return result;
};
